import {Button, Card, CardContent, Typography} from '@material-ui/core';
import {SvgIconProps} from '@material-ui/core/SvgIcon';
import React from 'react';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import './Card.sass';

type DashboardCardProps = {
  image: React.ComponentType<SvgIconProps> | React.FunctionComponent<any>;
  title: string;
  description: string;
  linkText: string;
  onClickLink: () => any;
  ariaLabel?: string;
};

const DashboardCard = (props: DashboardCardProps) => (
  <Card className="dashboard-card dashboard__fadeInRight ">
    <div className="dashboard__fade">
      <div className="dashboard-card__icon">
        <props.image className="dashboard-card__icon" />
      </div>
      <div className="dashboard-card__header">
        <Typography className="dashboard-card__title" variant="body1" component="h2">
          {props.title}
        </Typography>
      </div>
      <CardContent className="dashboard-card__description">
        <div>
          <Typography variant="caption" component="p" className="content">
            {props.description}
          </Typography>
        </div>
      </CardContent>
      <div className="dashboard-card__actions">
        <DashboardTileLinkButton
          title={props.title}
          onClickLink={props.onClickLink}
          linkText={props.linkText}
          ariaLabel={props.ariaLabel}
        />
      </div>
    </div>
  </Card>
);

export default DashboardCard;

const DashboardTileLinkButton = (props: Omit<DashboardCardProps, 'image' | 'description'>) => {
  const {title, linkText, onClickLink, ariaLabel} = props;
  return (
    <Button
      onClick={onClickLink}
      className="dashboard-card__link"
      id={`lob-entry-${toKebabCase(title)}`}
      aria-label={ariaLabel}
    >
      {linkText}
      <i className="fa fa-chevron-right dashboard-card__link-icon" aria-hidden="true" />
    </Button>
  );
};
